// Мини-приложение Telegram: подпись пользователя (initData) для входа в кабинеты без ссылки и пароля.
// Скрипт Telegram подключает App (setupTelegram) асинхронно — кабинеты ждут его не дольше нескольких секунд.

type TgWindow = { Telegram?: { WebApp?: { initData?: string } } };

/** Подпись Telegram, если скрипт уже загружен */
export const tgInitData = (): string => (window as unknown as TgWindow).Telegram?.WebApp?.initData || '';

/** Страница открыта внутри Telegram (метка в адресе или уже отмеченная вкладка) */
export function inTgApp(): boolean {
  try {
    return /tgWebApp/.test(location.hash + location.search) || sessionStorage.getItem('tgApp') === '1';
  } catch {
    return false;
  }
}

/** initData, дождавшись скрипта Telegram; не в Telegram — '' сразу */
export function waitTgInit(ms = 4000): Promise<string> {
  const now = tgInitData();
  if (now || !inTgApp()) return Promise.resolve(now);
  return new Promise((resolve) => {
    const start = Date.now();
    const t = setInterval(() => {
      const v = tgInitData();
      if (v || Date.now() - start > ms) { clearInterval(t); resolve(v); }
    }, 100);
  });
}

type TgUserRaw = { first_name?: string; last_name?: string; username?: string };

/** Пользователь Telegram в мини-приложении (без проверки подписи — только подсказка для формы) */
export function tgUser(): { name: string; username: string } | null {
  const u = (window as unknown as { Telegram?: { WebApp?: { initDataUnsafe?: { user?: TgUserRaw } } } }).Telegram?.WebApp?.initDataUnsafe?.user;
  if (!u || !tgInitData()) return null;
  return { name: [u.first_name, u.last_name].filter(Boolean).join(' ').trim(), username: u.username || '' };
}

/** Пустые имя и Telegram формы — из профиля Telegram */
export function withTgContact<T extends { name: string; telegram: string }>(form: T, user: { name: string; username: string } | null): T {
  if (!user) return form;
  return { ...form, name: form.name || user.name, telegram: form.telegram || (user.username ? `@${user.username}` : '') };
}
